import { render, staticRenderFns } from "./GeneralModal.vue?vue&type=template&id=6d13cd3c&scoped=true"
import script from "./GeneralModal.vue?vue&type=script&setup=true&lang=js"
export * from "./GeneralModal.vue?vue&type=script&setup=true&lang=js"
import style0 from "./GeneralModal.vue?vue&type=style&index=0&id=6d13cd3c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d13cd3c",
  null
  
)

export default component.exports